// extracted by mini-css-extract-plugin
export default {"anchor":"SearchPopover_anchor__gNx7-","popup":"SearchPopover_popup__pt0+F","search":"SearchPopover_search__Wha5I","footer":"SearchPopover_footer__aclqv"};